import { useState } from 'react'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'
import { ChurnStepper } from './components'

import { useFetch } from 'hooks'

import * as service from 'service'

const ChurnsShow = ({ match }) => {
  const {
    params: { churnId },
  } = match

  const [loading, setLoading] = useState(false)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.churns.show,
    { churnId },
    [],
  )

  const churn = response?.data?.churn

  return (
    <Page title="Visualização da solicitação de churn">
      <LoadingFeedback open={isLoading || loading} />
      {churn && (
        <Container maxWidth={false}>
          <ContentHeader
            menu="Solicitação de churn"
            title="Visualização"
            subtitle="Solicitação de churn"
          />
          <ChurnStepper
            churn={churn}
            setLoading={setLoading}
            refresh={refresh}
            show
          />
        </Container>
      )}
    </Page>
  )
}

export default ChurnsShow
